import { useEffect, useRef, useState, useContext } from "react";
import { useAuth } from "../../contexts/AuthContext";
import ServiceList, { ListOptions } from "./ServiceList";
import { DEFAULT_LIST_SORT } from "../../listSort";
import ServiceEdit from "./ServiceEdit";
import TechnicianServiceInterface from "./TechnicianServiceInterface";
import { hasAnyRole, isTechnician } from "../../utils/roles";
import { MDSplitView } from "@solsys/solsys-reactjs";

export default function ServiceController({
  navigate,
  action,
  id,
  search,
  style,
  options = {},
}) {
  let listState = {
    [ListOptions.sortBy]: DEFAULT_LIST_SORT.sortBy,
    [ListOptions.sortDirection]: DEFAULT_LIST_SORT.sortDirection,
    [ListOptions.name]: null,
    [ListOptions.craneId]: null,
    [ListOptions.statusId]: null,
  };
  const { user } = useAuth();
  const didMount = useRef(false);
  const allowedRoles = ["administrator", "technician"];
  const isTech = isTechnician(user);
  useEffect(() => (didMount.current ? undefined : (didMount.current = true)));
  if (!didMount.current && Object.keys(search).length) {
    Object.keys(ListOptions).forEach((key) => {
      listState[key] = search[key];
    });
  }

  listState = useState(listState);

  // Under crane: stay on list so narrow/mobile layouts show services first.
  // Standalone: default empty route to add (existing top-level behavior).
  const underCrane = Boolean(options.crane_id);
  const effectiveAction = underCrane
    ? (action || (id ? "edit" : "list"))
    : ((!action && !id) ? "add" : action);

  return (
    <div className="services">
      <MDSplitView
        globalName="ServiceMDV"
        style={ style }
        action={ effectiveAction }
        master={ ({ isNarrow, autoSelect }) => (
          <ServiceList
            isMaster={ hasAnyRole(user, allowedRoles) }
            state={ listState }
            id={ id }
            action={ effectiveAction }
            options={ options }
            onStateChange={ (state) => {
              navigate({
                action: effectiveAction,
                id,
                search: state,
                push: false,
              });
            } }
            onSelect={ (newId, userInteraction) => {
              // Stay nested under crane so options.crane_id is preserved.
              const popOut = underCrane ? false : isNarrow;
              if (
                newId &&
                id &&
                String(newId) === String(id) &&
                userInteraction
              ) {
                navigate({
                  popOut,
                  action: "list",
                  id: null,
                  search: listState[0],
                });
              } else {
                navigate({
                  popOut,
                  ...(newId === 0
                    ? {
                      action: "add",
                      id: null,
                    }
                    : {
                      action: "edit",
                      id: newId,
                    }),
                  search: listState[0],
                });
              }
            } }
          />
        ) }
        detail={ () => {
          const ServiceComponent = isTech ? TechnicianServiceInterface : ServiceEdit;
          return (
            <ServiceComponent
              key={ `action_${effectiveAction}_id_${id}` }
              id={ id }
              action={ effectiveAction }
              navigate={ navigate }
              options={ options }
            />
          );
        } }
        initialWidth={ 300 }
        maxWidth={ 800 }
        minWidth={ 290 }
      />
    </div>
  );
}
